export const Vue = {
    set(target, key, value) {
        target[key] = value;
    },
    delete(target, key) {
        delete target[key];
    }
};